class TableOfContent {
  constructor() {
    this.containers = document.querySelectorAll('.table-of-content-v2');
    this.init();
  }

  init() {
    if (this.containers.length === 0) return;

    this.containers.forEach(container => {
      this.setupDetailsElements(container);
    });

    // Re-initialize on section load (theme editor)
    document.addEventListener('shopify:section:load', () => {
      this.reinitialize();
    });
  }

  setupDetailsElements(container) {
    const detailsElements = container.querySelectorAll('details');
    
    detailsElements.forEach(details => {
      // Set open attribute
      details.setAttribute('open', '');
    });
  }

  reinitialize() {
    // Find new containers after section reload
    this.containers = document.querySelectorAll('.table-of-content-v2');
    this.containers.forEach(container => {
      this.setupDetailsElements(container);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new TableOfContent();
});

// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TableOfContent();
  });
} else {
  new TableOfContent();
}